module.exports = __webpack_public_path__ + "img/image03.adf99fbc.jpg";